export enum FilterTypes {
  TEXT = 0,
  NUMERO = 1,
  DATA = 2,
  BOOLEA = 3
}
